import * as actionTypes from "../actions/actionTypes";

const workTeams = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.GET_WORK_TEAMS:
      return { ...state, getAllWorkTeams: action.payload };
    default:
      return state;
  }
};

export default workTeams;
